import React from 'react';
import Layout from "./Layout";

const Service = () => {
    return (
        <div className={'container mt-5'}>
            <p>Tarpaulin Covering</p>
            <p>Plot Covering</p>
            <p>Wagon Door Packing / Sealing &amp; Water Proofing</p>
            <p>Escorting Service</p>
            <p>Excess Load Adjustment Services</p>
            <p>Inspection Services</p>
            <p><strong>We Specialize In...</strong></p>
            <p><strong></strong>Inspection of the materials to provide the needful services</p>
            <p>Covering with the world class materials</p>
            <p>Professional escort service</p>
            <p>To ensure safe transit of the materials</p>
            <p>Railway Wagon cleaning service before and after transportation.</p>
            <p>Fixing of Wooden Pegs and Wire Bindings to prevent any spillage of precious materials.</p>
            <p>Technical Expertise to the respective fields by our team members.</p>
            <h2><strong>Why Choose Us</strong></h2>
            <p><strong>Highly Skilled Team -</strong> We are ready to provide a highly skilled team for your service that has been developed since years.</p>
            <p></p>
            <p><strong>Strong Expertise -</strong> We have successfully completed over 200 jobs till date with almost all the reputed clients.</p>
            <p></p>
            <p><strong>Dedicated Support -</strong> You can avail the facility of our 24x7 basis support system to clarify any doubts regarding our service and your job.</p>


        </div>
    );
};

export default Layout(Service);